// extracted by mini-css-extract-plugin
export default {"Content":"EditRevisionFullView_Content__qHgnz"};